import { render } from "./BlogDetailsRightSidebarPage.vue?vue&type=template&id=8d94fd16&ts=true"
import script from "./BlogDetailsRightSidebarPage.vue?vue&type=script&lang=ts"
export * from "./BlogDetailsRightSidebarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__